import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Modal, ModalBody, ModalHeader, Row, Col, Form, Label, Input } from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createOrUpdateTag } from '../../store/service/actions';

const OnEditTagModal = ({ isOpen, toggle, tag, serviceId, onTagUpdated }) => {
  const dispatch = useDispatch();
  const validation = useFormik({
    enableReinitialize: true, 
    initialValues: {
      key_name: tag["key name"] || 'default',
      value: tag.value || '',     
    },
    validationSchema: Yup.object({
      value: Yup.string().required('Value is required'),
    }),
    onSubmit: async (values) => {
      const payload = {
        service_id: serviceId,
        key_name: tag["key name"],
        value: values.value,
      };
      try {
        dispatch(createOrUpdateTag(payload));
      } catch (error) {
        console.error("Failed to update tag:", error);
      }
      toggle(); 
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Edit Tag</ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <Row>
            <Col>
              <div className="mb-3">
                <Label htmlFor="key_name">Key Name</Label>
                <Input
                  id="key_name"
                  name="key_name"
                  type="text"
                  value={validation.values.key_name}
                  readOnly
                />
              </div>
              <div className="mb-3">
                <Label htmlFor="value">Key Value</Label>
                <Input
                  id="value"
                  name="value"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.value}
                />
                {validation.errors.value && validation.touched.value && (
                  <div className="text-danger">{validation.errors.value}</div>
                )}
              </div>
              <div className="text-end">
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};
OnEditTagModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  tag: PropTypes.object.isRequired,
  serviceId: PropTypes.any.isRequired,
  onTagUpdated: PropTypes.func.isRequired,
};

export default OnEditTagModal;
